<div class="close-icon" mat-button (click)="dialogRef.close()"></div>

<mat-dialog-content style="margin-top: 40px;">
  <h2
    style="font-family: Roboto, 'Helvetica Neue', sans-serif;">{{ list.recommendedSolutionsListId ? 'Edit' : 'Create' }} Recommended Solution List</h2>
  <div style="display: flex; flex-direction: row;">
    <div style="flex:50%">
      <mat-form-field style="width: 100%">
        <mat-label>Name</mat-label>
        <input matInput

               [(ngModel)]="list.name"
               required
        >
      </mat-form-field>
    </div>
    <div style="flex:1 1 auto">
      <img [src]="logoUrl" style="max-width: 64px; max-height: 64px;" *ngIf="list.logoFileName"/>
      <label class="mat-button mat-raised-button" for="updateClientCompanyLogo">
        <i class="pi pi-paperclip"></i> Upload new Logo
        <input id="updateClientCompanyLogo"
               type="file"
               (change)="addLogo($event)"
               name="updateClientCompanyLogo"
               style="display: none;"/>
      </label>
    </div>
  </div>
  <div mat-dialog-actions>
    <button mat-raised-button (click)="save()" style="border-radius: 6px;">Save</button>
    <button mat-raised-button style="border-radius: 6px;" (click)="close()">Cancel</button>
  </div>
</mat-dialog-content>
